module.exports = __webpack_public_path__ + "static/img/4.6c74fdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/4.png
// module id = y90B
// module chunks = 0